import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MultiSelectList } from 'src/domains/common/components/multi-select-list/multi-select-list';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { useCommon } from 'src/AppState/Common';

export type SportsPickerPropsType = {
    campaignId?: string;
    disabled?: boolean;
};

export const SportsPicker = observer('SportsPicker', ({ campaignId, disabled }: SportsPickerPropsType): JSX.Element => {
    const common = useCommon();
    const sportsPickerState = CampaignCreatorState.get(common, campaignId).actionConditionsState
        .sportsbookSelectionsState.sportsPickerState;

    const {
        showAllBadges,
        expanded,
        visibleCheckedWithLabels,
        visibleChecked,
        filteredNodes,
        keywordInputState,
        checked,
        isLoading,
        toggleShowAllBadges,
        clearChecked,
        handleCheck,
        handleExpand,
        setKeyword,
        handleRemoveChecked,
    } = sportsPickerState;

    return (
        <div className='flex flex-col gap-2 relative'>
            {isLoading && (
                <div className='absolute top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center flex-auto gap-6 p-6 bg-white/75 font-tertiary flex-nowrap animate-pulse'>
                    <div className='w-8 h-8 border-4 border-dashed rounded-full animate-spin border-foreground' />
                </div>
            )}
            <MultiSelectList
                filteredNodes={filteredNodes}
                showAllBadges={showAllBadges}
                checked={checked}
                visibleChecked={visibleChecked}
                keywordInputState={keywordInputState}
                expanded={expanded}
                visibleCheckedWithLabels={visibleCheckedWithLabels}
                toggleShowAllBadges={toggleShowAllBadges}
                clearChecked={clearChecked}
                handleCheck={handleCheck}
                handleExpand={handleExpand}
                setKeyword={setKeyword}
                handleRemoveChecked={handleRemoveChecked}
                remaining={visibleChecked.remaining}
                remainingLabel='Items'
                disabled={disabled}
                noCascade
            />
        </div>
    );
});
